import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	destroyInstructions,
	playUISound,
} from "../helpers/levelManager"
import { displayInstructions } from "../helpers/levelManager"
import { MediclinicAPI } from "../helpers/apiHandler"
export default class Customization extends Phaser.Scene {
	constructor() {
		super({ key: "Customization" })
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		let scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Create a container for all UI elements to make positioning easier
		this.uiContainer = null

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		// Standard button spacing
		this.xOffset = 300 * this.scaleFactor
	
		this.apiHandler = new MediclinicAPI()
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		// Add background that fills the entire screen
		this.background = this.add
			.image(this.gameW / 2, this.gameH / 2, "customizationBG")
			.setScale(this.scaleFactor * 0.5)

		// Create a container for UI elements
		this.uiContainer = this.add.container(this.safeZoneX, this.safeZoneY)

		// Start with tribe selection
		this.chooseTribe()
		//this.customizationDone();

		// Add window resize listener to update element positions
		//this.scale.on("resize", this.onResize, this)
	}

	// Handle window resize events
	// onResize(gameSize) {
	// 	console.log("Resize")
	// 	// Update game dimensions
	// 	this.gameW = gameSize.width
	// 	this.gameH = gameSize.height

	// 	// Recalculate scaling factors
	// 	let scalingData = calculateScaleFactor(this)
	// 	this.scaleFactor = scalingData.scaleFactor
	// 	this.safeZoneX = scalingData.safeZoneX
	// 	this.safeZoneY = scalingData.safeZoneY
	// 	this.safeZoneWidth = scalingData.safeZoneWidth
	// 	this.safeZoneHeight = scalingData.safeZoneHeight

	// 	// Update spacing based on new scale factor
	// 	this.xOffset = 300 * this.scaleFactor

	// 	// Update container position
	// 	if (this.uiContainer) {
	// 		this.uiContainer.setPosition(this.safeZoneX, this.safeZoneY)
	// 	}
	// }

	// Choose tribe function
	chooseTribe() {
		// Update top bar text
		//this.topBarText.setText("Choose your exploration tribe!");
		displayInstructions(this, "Choose your suit!", 15, 200, 50)
		let tribeScale = this.scaleFactor * 0.45

		// Create tribe buttons with proper scaling and positioning
		let tribe01 = this.add
			.image(
				this.safeZoneWidth / 2 - this.xOffset + 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"astronaut01Default",
			)
			.setScale(tribeScale)
			.setInteractive()
			.setDepth(3)
		this.uiContainer.add(tribe01)

		let originalScale = tribe01.scale

		let tribe02 = this.add
			.image(
				this.safeZoneWidth / 2,
				this.safeZoneHeight / 2,
				"astronaut02Default",
			)
			.setScale(tribeScale)
			.setInteractive()
		this.uiContainer.add(tribe02)

		let tribe03 = this.add
			.image(
				this.safeZoneWidth / 2 + this.xOffset - 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"astronaut03Default",
			)
			.setScale(tribeScale)
			.setInteractive()
		this.uiContainer.add(tribe03)

		// Use arrow functions to preserve 'this' context
		tribe01.on("pointerdown", () =>
			this.tribeOption(
				1,
				tribe01,
				tribe02,
				tribe03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		tribe02.on("pointerdown", () =>
			this.tribeOption(
				2,
				tribe01,
				tribe02,
				tribe03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		tribe03.on("pointerdown", () =>
			this.tribeOption(
				3,
				tribe01,
				tribe02,
				tribe03,
				originalScale,
				nextButton,
				nextText,
			),
		)

		// Create next button
		let nextButton = this.add
			.image(
				this.safeZoneWidth / 2 + 340 * this.scaleFactor,
				this.safeZoneHeight / 2 + 110 * this.scaleFactor,
				"miniWideBtn",
			)
			.setInteractive()
			.setScale(0.5 * this.scaleFactor)
			.setAlpha(0.5)
		this.uiContainer.add(nextButton)

		// Add next button text
		let nextText = this.add
			.text(nextButton.x, nextButton.y - 8 * this.scaleFactor, "NEXT", {
				fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				fill: "#E5EBFF",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setAlpha(0.5)
		this.uiContainer.add(nextText)

		// Add click event to next button
		nextButton.on("pointerdown", () => {
			if (!this.tribeChosen) {
				console.error("Choose Tribe!!")
				return
			}
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Clean up current elements
			tribe01.destroy()
			tribe02.destroy()
			tribe03.destroy()
			nextButton.destroy()
			nextText.destroy()

			// Move to next step
			this.chooseRocketStyle()
		})
	}

	tribeOption(
		selectedIndex,
		tribe01,
		tribe02,
		tribe03,
		originalScale,
		nextButton,
		nextText,
	) {
		playUISound(this, this.soundManager, "blib", 0.25)
		// Clear existing effects on tribe images
		;[tribe01, tribe02, tribe03].forEach((tribe) => {
			if (tribe.postFX) tribe.postFX.clear()
			tribe.setScale(originalScale)
		})

		// Apply new effects based on the selected tribe
		const glowEffectConfig = {
			color: 0xffffff,
			distance: 4,
			strength: 0,
			quality: false,
			pixelWidth: 0.1,
			pixelHeight: 10,
		}
		const selectedScale = originalScale + 0.03 * this.scaleFactor

		switch (selectedIndex) {
			case 1:
				tribe01.setScale(selectedScale)
				tribe01.setTexture("astronaut01Active")
				tribe02.setTexture("astronaut02Default")
				tribe03.setTexture("astronaut03Default")
				//tribe01.postFX.addGlow("0x7FF9FF", glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 2:
				tribe02.setScale(selectedScale)
				tribe01.setTexture("astronaut01Default")
				tribe02.setTexture("astronaut02Active")
				tribe03.setTexture("astronaut03Default")
				//tribe02.postFX.addGlow('0xFCB03A', glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 3:
				tribe03.setScale(selectedScale)
				tribe01.setTexture("astronaut01Default")
				tribe02.setTexture("astronaut02Default")
				tribe03.setTexture("astronaut03Active")
				//tribe03.postFX.addGlow('0xD8A5FF', glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
		}

		nextButton.setAlpha(1)
		nextText.setAlpha(1)
		this.tribeChosen = selectedIndex
		console.log(this.tribeChosen)
	}

	// Choose rocket style function
	chooseRocketStyle() {
		// Update top bar text
		//this.topBarText.setText("Choose Your Rocket Style!");
		displayInstructions(this, "Choose your spaceship!", 15, 200, 50)

		let rocketScale = this.scaleFactor * 0.6
		// Create rocket style buttons
		let rocket01 = this.add
			.image(
				this.safeZoneWidth / 2 - this.xOffset + 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"spaceship01Default",
			)
			.setScale(rocketScale)
			.setInteractive()
		this.uiContainer.add(rocket01)

		let originalScale = rocket01.scale

		let rocket02 = this.add
			.image(
				this.safeZoneWidth / 2,
				this.safeZoneHeight / 2,
				"spaceship02Default",
			)
			.setScale(rocketScale)
			.setInteractive()
		this.uiContainer.add(rocket02)

		let rocket03 = this.add
			.image(
				this.safeZoneWidth / 2 + this.xOffset - 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"spaceship03Default",
			)
			.setScale(rocketScale)
			.setInteractive()
		this.uiContainer.add(rocket03)

		rocket01.on("pointerdown", () =>
			this.rocketOption(
				1,
				rocket01,
				rocket02,
				rocket03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		rocket02.on("pointerdown", () =>
			this.rocketOption(
				2,
				rocket01,
				rocket02,
				rocket03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		rocket03.on("pointerdown", () =>
			this.rocketOption(
				3,
				rocket01,
				rocket02,
				rocket03,
				originalScale,
				nextButton,
				nextText,
			),
		)

		// Create next button
		let nextButton = this.add
			.image(
				this.safeZoneWidth / 2 + 340 * this.scaleFactor,
				this.safeZoneHeight / 2 + 110 * this.scaleFactor,
				"miniWideBtn",
			)
			.setInteractive()
			.setScale(0.5 * this.scaleFactor)
			.setAlpha(0.5)
		this.uiContainer.add(nextButton)

		// Add next button text
		let nextText = this.add
			.text(nextButton.x, nextButton.y - 8 * this.scaleFactor, "NEXT", {
				fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				fill: "#E5EBFF",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setAlpha(0.5)
		this.uiContainer.add(nextText)

		// Add click event to next button
		nextButton.on("pointerdown", () => {
			if (!this.rocketChosen) {
				console.error("Choose Rocket!!")
				return
			}
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Clean up current elements
			rocket01.destroy()
			rocket02.destroy()
			rocket03.destroy()
			nextButton.destroy()
			nextText.destroy()

			// Move to next step
			this.chooseDashboard()
		})
	}

	rocketOption(
		selectedIndex,
		rocket01,
		rocket02,
		rocket03,
		originalScale,
		nextButton,
		nextText,
	) {
		// Clear existing effects on rocket images
		;[rocket01, rocket02, rocket03].forEach((rocket) => {
			if (rocket.postFX) rocket.postFX.clear()
			rocket.setScale(originalScale)
		})

		playUISound(this, this.soundManager, "blib", 0.25)
		// Apply new effects based on the selected rocket
		const glowEffectConfig = {
			color: 0xffffff,
			distance: 4,
			strength: 0,
			quality: false,
			pixelWidth: 0.1,
			pixelHeight: 10,
		}
		const selectedScale = originalScale + 0.06 * this.scaleFactor

		switch (selectedIndex) {
			case 1:
				rocket01.setScale(selectedScale)
				rocket01.setTexture("spaceship01Active")
				rocket02.setTexture("spaceship02Default")
				rocket03.setTexture("spaceship03Default")
				//rocket01.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 2:
				rocket02.setScale(selectedScale)
				rocket01.setTexture("spaceship01Default")
				rocket02.setTexture("spaceship02Active")
				rocket03.setTexture("spaceship03Default")
				//rocket02.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 3:
				rocket03.setScale(selectedScale)
				rocket01.setTexture("spaceship01Default")
				rocket02.setTexture("spaceship02Default")
				rocket03.setTexture("spaceship03Active")
				//rocket03.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
		}

		nextButton.setAlpha(1)
		nextText.setAlpha(1)

		this.rocketChosen = selectedIndex
	}

	// Choose dashboard function
	chooseDashboard() {
		// Update top bar text
		//this.topBarText.setText("How about a dashboard ornament?");
		displayInstructions(
			this,
			"Choose a dashboard ornament!",
			15,
			300,
			50,
		)
		//this.topBar.setScale(0.35 * this.scaleFactor, 0.25 * this.scaleFactor);

		// Calculate positions for dashboard ornaments evenly across the screen
		let spacing = this.safeZoneWidth / 5
		let startX = spacing

		// Create dashboard ornament buttons
		let dashScale = this.scaleFactor * 0.55
		// Create rocket style buttons
		let dash01 = this.add
			.image(
				this.safeZoneWidth / 2 - this.xOffset + 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"ornament01Default",
			)
			.setScale(dashScale)
			.setInteractive()
		this.uiContainer.add(dash01)

		let originalScale = dash01.scale

		let dash02 = this.add
			.image(
				this.safeZoneWidth / 2,
				this.safeZoneHeight / 2,
				"ornament02Default",
			)
			.setScale(dashScale)
			.setInteractive()
		this.uiContainer.add(dash02)

		let dash03 = this.add
			.image(
				this.safeZoneWidth / 2 + this.xOffset - 100 * this.scaleFactor,
				this.safeZoneHeight / 2,
				"ornament03Default",
			)
			.setScale(dashScale)
			.setInteractive()
		this.uiContainer.add(dash03)

		dash01.on("pointerdown", () =>
			this.dashOption(
				1,
				dash01,
				dash02,
				dash03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		dash02.on("pointerdown", () =>
			this.dashOption(
				2,
				dash01,
				dash02,
				dash03,
				originalScale,
				nextButton,
				nextText,
			),
		)
		dash03.on("pointerdown", () =>
			this.dashOption(
				3,
				dash01,
				dash02,
				dash03,
				originalScale,
				nextButton,
				nextText,
			),
		)

		// Create next button
		let nextButton = this.add
			.image(
				this.safeZoneWidth / 2 + 340 * this.scaleFactor,
				this.safeZoneHeight / 2 + 110 * this.scaleFactor,
				"miniWideBtn",
			)
			.setInteractive()
			.setScale(0.5 * this.scaleFactor)
			.setAlpha(0.5)
		this.uiContainer.add(nextButton)

		// Add next button text
		let nextText = this.add
			.text(nextButton.x, nextButton.y - 8 * this.scaleFactor, "NEXT", {
				fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				fill: "#E5EBFF",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setAlpha(0.5)
		this.uiContainer.add(nextText)

		// Add click event to next button
		nextButton.on("pointerdown", () => {
			if (!this.dashChosen) {
				console.error("Choose Ornament!!")
				return
			}
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Clean up current elements
			dash01.destroy()
			dash02.destroy()
			dash03.destroy()
			nextButton.destroy()
			nextText.destroy()

			destroyInstructions(this)

			// Move to completion
			this.customizationDone()
		})
	}

	dashOption(
		selectedIndex,
		dash01,
		dash02,
		dash03,
		originalScale,
		nextButton,
		nextText,
	) {
		// Clear existing effects on dash images
		;[dash01, dash02, dash03].forEach((dash) => {
			if (dash.postFX) dash.postFX.clear()
			dash.setScale(originalScale)
		})

		playUISound(this, this.soundManager, "blib", 0.25)
		// Apply new effects based on the selected dash
		const glowEffectConfig = {
			color: 0xffffff,
			distance: 4,
			strength: 0,
			quality: false,
			pixelWidth: 0.1,
			pixelHeight: 10,
		}
		const selectedScale = originalScale + 0.06 * this.scaleFactor

		switch (selectedIndex) {
			case 1:
				dash01.setScale(selectedScale)
				dash01.setTexture("ornament01Active")
				dash02.setTexture("ornament02Default")
				dash03.setTexture("ornament03Default")
				//dash01.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 2:
				dash02.setScale(selectedScale)
				dash01.setTexture("ornament01Default")
				dash02.setTexture("ornament02Active")
				dash03.setTexture("ornament03Default")
				//dash02.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
			case 3:
				dash03.setScale(selectedScale)
				dash01.setTexture("ornament01Default")
				dash02.setTexture("ornament02Default")
				dash03.setTexture("ornament03Active")
				//dash03.postFX.addGlow(glowEffectConfig.color, glowEffectConfig.distance, glowEffectConfig.strength, glowEffectConfig.quality, glowEffectConfig.pixelWidth, glowEffectConfig.pixelHeight);
				break
		}

		nextButton.setAlpha(1)
		nextText.setAlpha(1)

		this.dashChosen = selectedIndex
	}

	customizationDone() {
		console.log(
			"Tribe chosen: " + this.tribeChosen + "\n",
			"Rocket chosen: " + this.rocketChosen + "\n",
			"Ornament Chosen: " + this.dashChosen,
		)

		this.saveCustomData()

		let container = this.add
			.image(
				this.safeZoneWidth / 2 - 220 * this.scaleFactor,
				this.safeZoneHeight / 2 - 20 * this.scaleFactor,
				"customizationContainer",
			)
			.setScale(0.5 * this.scaleFactor)
		this.uiContainer.add(container)

		let chosenRocket = this.add
			.image(
				container.x + 10 * this.scaleFactor,
				container.y - 20 * this.scaleFactor,
				"spaceship0" + this.rocketChosen,
			)
			.setScale(0.355 * this.scaleFactor)
		this.uiContainer.add(chosenRocket)

		let chosenTribe = this.add
			.image(
				container.x - 70 * this.scaleFactor,
				container.y + 1 * this.scaleFactor,
				"astronaut0" + this.tribeChosen,
			)
			.setScale(0.23 * this.scaleFactor)
			.setDepth(2)
		this.uiContainer.add(chosenTribe)

		let chosenOrnament = this.add
			.image(
				container.x + 50 * this.scaleFactor,
				container.y + 70 * this.scaleFactor,
				"ornament0" + this.dashChosen,
				//ornament03Default
				//"tribe0" + this.tribeChosen
			)
			.setScale(this.scaleFactor / 3.5)
		this.uiContainer.add(chosenOrnament)

		let container02 = this.add
			.image(
				this.safeZoneWidth / 2 + 160 * this.scaleFactor,
				this.safeZoneHeight / 2 - 20 * this.scaleFactor,
				"wideContainer",
			)
			.setScale(this.scaleFactor * 0.75, this.scaleFactor * 0.6)
		this.uiContainer.add(container02)

		let text01 = this.add
			.text(
				container02.x - 180 * this.scaleFactor,
				container02.y - 50 * this.scaleFactor,
				"Looking good, Medinaut!",
				{
					fontSize: Math.round(this.fontSize - 1 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0, 0.5)
		this.uiContainer.add(text01)

		let text02 = this.add
			.text(
				container02.x - 95 * this.scaleFactor,
				text01.y + 30 * this.scaleFactor,
				"Time to take to the skies!",
				{
					fontSize: Math.round(this.fontSize - 6 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "400",
					resolution: 2,					
					align: "left"
				},
			)
			.setOrigin(0.5)
		this.uiContainer.add(text02)

		let nextButton = this.add
			.image(
				container02.x + 110 * this.scaleFactor,
				container02.y + 25 * this.scaleFactor,
				"normalWideBtn",
			)
			.setInteractive()
			.setScale(0.5 * this.scaleFactor)
		this.uiContainer.add(nextButton)

		let textButton = this.add
			.text(nextButton.x, nextButton.y - 10 * this.scaleFactor, "LIFT OFF!", {
				fontSize: Math.round(this.fontSize + 3 * this.scaleFactor) + "px",
				fill: "#E5EBFF",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
		this.uiContainer.add(textButton)

		nextButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.cameras.main.fadeOut(500)
			this.time.delayedCall(
				500,
				function () {
					this.scene.start("PlanetSelector")
				},
				[],
				this,
			)
		})
	}

	saveCustomData() {
		// let userData = this.cache.json.get('userData');

		// // Update only the customization section
		// userData.customization.tribe = this.tribeChosen || userData.customization.tribe;
		// userData.customization.rocket = this.rocketChosen || userData.customization.rocket;
		// userData.customization.ornament = this.dashChosen || userData.customization.ornament;
		// userData.customizationCompleted = true;
		// //userData.userLevel = 1;

		// // Save updated data back to cache
		// this.cache.json.add('userData', userData);

		// // Debugging output
		// console.log("Updated User Data:", userData);

		// if (localStorage.getItem('userData') !== null) {
		//     //localStorage.removeItem('userData');
		//     console.log('DataExists');
		// }
		// else {
		//     //console.log("create json now");
		//     localStorage.setItem('userData', JSON.stringify(userData));
		// }

		let savedUserData = checkLocalSavedData()
		savedUserData.customization.tribe =
			this.tribeChosen || savedUserData.customization.tribe
		savedUserData.customization.rocket =
			this.rocketChosen || savedUserData.customization.rocket
		savedUserData.customization.ornament =
			this.dashChosen || savedUserData.customization.ornament
		savedUserData.customizationCompleted = true
		//this.cache.json.add('userData', savedUserData);

		localStorage.setItem("userData", JSON.stringify(savedUserData))

		console.log(
			"DENNIS NUMBER 2 Tribe Chosen " +
				this.tribeChosen +
				this.rocketChosen +
				this.dashChosen,
		)

		// const customizationData = {
		// 	playerId: savedUserData.userID,
		// 	tribe: savedUserData.customization.tribe,
		// 	rocket: savedUserData.customization.rocket,
		// 	ornament: savedUserData.customization.ornament,
		// }

		// try {
		// 	await this.apiHandler.recordCustomization(customizationData)
		// 	console.log("Customization data submitted successfully!")
		// } catch (error) {
		// 	console.error("Failed to submit customization:", error)
		// }
	}
}
